import React from "react";

function InstagramFooter() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0855 5.65642C15.8657 5.65642 15.6875 5.47821 15.6875 5.25839C15.6875 5.03856 15.8657 4.86035 16.0855 4.86035"
        stroke="#686868"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0854 5.65642C16.3053 5.65642 16.4835 5.47821 16.4835 5.25839C16.4835 5.03856 16.3053 4.86035 16.0854 4.86035"
        stroke="#686868"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 5.31828C1 3.0558 2.83411 1.22168 5.09661 1.22168H16.021C18.2834 1.22168 20.1175 3.0558 20.1175 5.31828V16.2426C20.1175 18.505 18.2834 20.3392 16.021 20.3392H5.09661C2.83411 20.3392 1 18.505 1 16.2426V5.31828Z"
        stroke="#686868"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49878 10.7807C6.49878 11.8574 6.92652 12.8901 7.68791 13.6515C8.44931 14.4129 9.48197 14.8406 10.5587 14.8406C11.6355 14.8406 12.6682 14.4129 13.4296 13.6515C14.191 12.8901 14.6187 11.8574 14.6187 10.7807C14.6187 9.7039 14.191 8.67123 13.4296 7.90984C12.6682 7.14845 11.6355 6.7207 10.5587 6.7207C9.48197 6.7207 8.44931 7.14845 7.68791 7.90984C6.92652 8.67123 6.49878 9.7039 6.49878 10.7807Z"
        stroke="#686868"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default InstagramFooter;
